<template>
  <artisio-modal size="lg" ref="ReleaseNoteModal" :visible="modal.show" :content-in-form="false"
                 :title="computedTitle" @hidden="onHidden" :show-confirmation="false" scrollable>
    <general-loader v-if="loading" loading/>
    <div v-html="computedBody" v-else/>
    <template v-slot:modal-footer>
      <div class="mr-auto" style="width: 21em" v-if="modal.doNotShowAgainVisible">
        <b-form-checkbox v-model="doNotShowAgain">
          {{ $t("Do not show this message again.") }}
        </b-form-checkbox>
      </div>
      <cancel-button @click="onDismissClick" v-if="modal.doNotShowAgainVisible">
        {{ $t('Dismiss') }}
      </cancel-button>
      <cancel-button @click="onHidden" v-else>
        {{ $t('Close') }}
      </cancel-button>
      <submit-button @click="onReleaseNotesListClick" :show-loader="releaseNotesLoading">
        {{ $t('View Release Notes')}}
      </submit-button>
    </template>
  </artisio-modal>
</template>

<script>
  import ArtisioModal from "../../artisio-modal/ArtisioModal.vue";
  import CancelButton from "@/core/components/common/CancelButton.vue";
  import {createNamespacedHelpers} from "vuex";
  import {RELEASE_NOTE_DISMISSED} from "@/modules/constants";
  import {Formatter} from "@/core/services/formatter.service";
  import SubmitButton from "@/core/components/common/SubmitButton.vue";
  import ReleaseNotesService from "@/modules/common/ReleaseNotesService";
  import GeneralLoader from "@/core/components/general-loader/GeneralLoader.vue";

  const {mapState, mapActions} = createNamespacedHelpers('global')
  export default {
    name: "ReleaseNoteModal",
    components: {GeneralLoader, SubmitButton, CancelButton, ArtisioModal},
    data() {
      return {
        doNotShowAgain: false,
        body: null,
        loading: false
      }
    },
    computed: {
      ...mapState({
        modal: state => state.releaseNoteModal,
        releaseNotesLoading: state => state.releaseNotesListModal.loading
      }),
      computedTitle() {
        if (!this.modal.releaseNote) {
          return ''
        }
        return this.$i18n.t('Release note for version {version} — {date}',
            {version: this.modal.releaseNote.version, date: Formatter.toDateTime(this.modal.releaseNote.date)})
      },
      computedBody() {
        if (!this.modal.releaseNote) {
          return ''
        }
        return this.body ? this.body : this.$i18n.t('Artisio AMS was updated to version {version}.',
            {version: this.modal.releaseNote.version})
      },
    },
    methods: {
      ...mapActions(['hideReleaseNoteModal', 'showReleaseNotesListModal']),
      onHidden() {
        this.clearModal()
        this.hideReleaseNoteModal()
      },
      onReleaseNotesListClick(){
        if (this.doNotShowAgain) {
          localStorage.setItem(RELEASE_NOTE_DISMISSED, this.modal.releaseNote.uuid)
        }
        this.clearModal()
        this.showReleaseNotesListModal()
      },
      onDismissClick() {
        if (this.doNotShowAgain) {
          localStorage.setItem(RELEASE_NOTE_DISMISSED, this.modal.releaseNote.uuid)
        }
        this.onHidden()
      },
      clearModal(){
        this.doNotShowAgain = false
        this.body = null
        this.loading = false
      }
    },
    watch: {
      async 'modal.releaseNote.uuid'() {
        if (this.modal.releaseNote && this.modal.releaseNote.uuid) {
          this.loading = true
          const response = await ReleaseNotesService.getReleaseNote(this.modal.releaseNote.uuid)
          if (response.success) {
            this.body = response.body.body
            this.loading = false
          }
          else {
            this.$toast('danger', this.$i18n.t('Failed to load release notes'))
            this.clearModal()
            this.onHidden()
          }

        }
      }
    }
  }

</script>
<style scoped>

</style>